import React from "react";

const EnvelopeImage = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
            <g id="Layer_3" data-name="Layer 3">
                <polygon style={{ fill: '#eaca6a'}} points="68.1 77.1 68.1 118.77 131.9 118.77 131.9 75.8 100.65 99.24 68.1 77.1"/>
                <path style={{ fill: '#3c4244'}} d="M132.9,119.77H67.1V75.21L100.62,98,132.9,73.8Zm-63.81-2H130.9v-40l-30.22,22.67L69.1,79Z"/>
                <polygon style={{ fill: '#fff'}} points="127.87 78.84 127.87 56.1 120.42 49 72.13 49 72.13 79.63 100.14 99.8 127.87 78.84"/>
                <path style={{ fill: '#3c4244'}} d="M100.15,101l-29-20.9V48h49.69l8.06,7.67V79.34Zm-27-21.93,27,19.44,26.75-20.21V56.53L120,50H73.13Zm54.74-.27h0Z"/>
                <path style={{ fill: '#3c4244'}} d="M94.2,59H78.58a1,1,0,0,1,0-2H94.2a1,1,0,0,1,0,2Z"/>
                <path style={{ fill: '#3c4244'}} d="M94.2,65.47H78.58a1,1,0,0,1,0-2H94.2a1,1,0,0,1,0,2Z"/>
                <polyline style={{ fill: '#eaca6a'}} points="127.07 57.18 119.72 57.18 119.72 49.84"/>
                <path style={{ fill: '#3c4244'}} d="M127.07,58.18h-8.34V49.84a1,1,0,1,1,2,0v6.34h6.34a1,1,0,1,1,0,2Z"/>
            </g>
        </svg>
    )
}

export default EnvelopeImage;